// Persistencia local de BINARIOS de fotos pendientes (offline real de fotos, v1).
// A diferencia de `offlineMantencionStore` (JSON chico en localStorage), las fotos
// son binarios → se guardan en IndexedDB vía localforage, que serializa Blob/File
// nativamente (sin base64). Cada registro se keyea por un `localId` único de la foto.
//
// El binario sobrevive recargas/cierre de la app sin red; el daemon de sync lo sube
// a S3 al reconectar (contra el idHallazgo que recién aparece tras el PUT de
// mantención) y luego lo borra. Mapea por `mantencionId` + `idRes` + `tipo`.
//
// Todo best-effort: si IndexedDB falla (no disponible/privado/quota), las funciones
// degradan a no-op / null / [] sin lanzar, así el flujo en memoria sigue funcionando.
import localforage from 'localforage';

const store = localforage.createInstance({
  name: 'prolift',
  storeName: 'offline-photos',
});

const sameMantencion = (rec, mantencionId) =>
  rec != null && String(rec.mantencionId) === String(mantencionId);

// savePhoto(localId, { blob, name, type, mantencionId, idRes, tipo }) — persiste el
// binario + metadatos. `createdAt` lo setea el store (pisa el del caller).
export async function savePhoto(localId, data) {
  if (localId == null) return;
  try {
    await store.setItem(String(localId), {
      ...data,
      localId: String(localId),
      createdAt: Date.now(),
    });
  } catch {
    // best-effort: idb no disponible / quota
  }
}

export async function loadPhoto(localId) {
  if (localId == null) return null;
  try {
    return (await store.getItem(String(localId))) ?? null;
  } catch {
    return null;
  }
}

export async function listPhotosForMantencion(mantencionId) {
  const out = [];
  try {
    await store.iterate((rec) => {
      if (sameMantencion(rec, mantencionId)) out.push(rec);
    });
  } catch {
    return [];
  }
  return out;
}

export async function deletePhoto(localId) {
  if (localId == null) return;
  try {
    await store.removeItem(String(localId));
  } catch {
    // best-effort
  }
}

export async function deletePhotosForMantencion(mantencionId) {
  try {
    const toDelete = [];
    await store.iterate((rec, key) => {
      if (sameMantencion(rec, mantencionId)) toDelete.push(key);
    });
    for (const key of toDelete) {
      // eslint-disable-next-line no-await-in-loop
      await store.removeItem(key);
    }
  } catch {
    // best-effort
  }
}
